export const AIRTICKET_HALF_REFUND = 'AIRTICKET_HALF_REFUND';
export const airtickethalfrefundTags = ['AirTicketHalfRefund'];
export const MANUAL_REFUND = 'MANUAL_REFUND';
export const manualrefundTags = ['ManualRefund'];
export const INVOICE = 'Invoices';
